import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import createPersistedState from "vuex-persistedstate"

const changeMeta = (nowPath, fromType) => {
  let firstModule = nowPath.split("/")[1];
  let routes = router.options.routes;
  let firstPathIndex = routes.findIndex((v) => v.path.indexOf(firstModule) != -1);
  // 获取路由里面的二级path
  let secondModule = nowPath.split("/")[2]; //路由只能有一个/代表的内容，否则失效
  let secondPathIndex = routes[firstPathIndex].children.findIndex((v) => v.path == secondModule);
  if (fromType == 'cancelKeep') {
    // 点击左侧栏或者最顶部headr
    router.options.routes[firstPathIndex].children[secondPathIndex].meta.keepAlive = false
  } else if (fromType == 'saveKeep') {
    router.options.routes[firstPathIndex].children[secondPathIndex].meta.keepAlive = true
  }
}

import oem from '@/oem/oem.js'
console.log(oem, 'oem')
const store = new Vuex.Store({
  state: {
    oem: oem,
    ver: '25080900001',
    smCloud: {
      mch_id: '', // 手机号
      user_id: '', // id
      user_name: '', // 名称
      supperAuth: '', //超级管理员
      // srvUrl: 'https://www.91byk.com/smSellTest',
      dutyYn: '',
      lng: 'zh-CN',
      lng_name: '中文',
      mall_id: '10011001',
      load_url: '', //https://www.91byk.com/smSellTest
      mall_name: '',
      auth_ja: '',
    },
    smCloudToken: "", // 本地token
    orgAuth: [],
    userAuth: [],

    visitedMenus: [],
    menuNames: []
  },
  mutations: {
    setState(state, { key, value }) {
      state.smCloud[key] = value;
    },
    setOemState(state, { key, value }) {
      state.oem[key] = value;
    },
    // 储存用户上一次登录手机号
    mch_id(state, data) {
      state.smCloud.mch_id = data;
    },
    mall_id(state, data) {
      state.smCloud.mall_id = '10011001';
    },
    mall_name(state, data) {
      state.smCloud.mall_name = data;
    },
    user_id(state, data) {
      state.smCloud.user_id = data;
    },
    user_name(state, data) {
      state.smCloud.user_name = data;
    },
    load_url(state, data) {
      console.log(data, 'data')
      state.smCloud.load_url = data;
    },
    lng(state, data) {
      state.smCloud.lng = data;
    },
    lng_name(state, data) {
      state.smCloud.lng_name = data;
    },


    supperAuth(state, data) {
      state.smCloud.supperAuth = data;
    },

    smCloudToken(state, data) {
      state.smCloudToken = data;
    },


    setVisitedMenus(state, value) {
      state.visitedMenus = value
    },
    setVisitedMenusName(state, value) {
      state.menuNames = value
    },
    addRouteMenus(state, routeMenu) {
      if (routeMenu.route.path != '/login' && routeMenu.route.path != '/register') {
        let hasMenu = state.visitedMenus.some(item => item.path == routeMenu.route.path) //判断此路由是否在已存储的路由数据中
        if (!hasMenu) {
          // 如果存储的路由数据中，没有此路由就新增
          state.visitedMenus.push(Object.assign({}, {
            path: routeMenu.route.path,
            titleText: routeMenu.route.meta.titleText,
            query: routeMenu.route.query,
          }))
          state.menuNames.push(routeMenu.route.name)
          changeMeta(routeMenu.route.path, "saveKeep"); //保持数据缓存应该在路由导航前设置，否则还会保持原来的数据。好像可以删除没啥用
        }
      }
    },

  },
  plugins: [createPersistedState({
    key: 'smCloud'
  })]
})
store.commit('setOemState', { key: 'title', value: oem.title })
store.commit('setOemState', { key: 'logo', value: oem.logo })
store.commit('setOemState', { key: 'favicon', value: oem.favicon })

let link = document.querySelector('link[rel="icon"]');
if (!link) {
  link = document.createElement('link');
  link.rel = 'icon';
  link.type = 'image/x-icon';
  document.head.appendChild(link);
}
link.href = store.state.oem.favicon;
console.log('favicon updated to:', store.state.oem.favicon);

export default store



// WEBPACK FOOTER //
// ./src/store/index.js